module.exports = __webpack_public_path__ + "static/media/User.f0e22210.png";